module.exports = __webpack_public_path__ + "img/security6.041fbf66.png";